import { render, staticRenderFns } from "./SubMenuTab_Base.vue?vue&type=template&id=627f2e82&"
import script from "./SubMenuTab_Base.vue?vue&type=script&lang=js&"
export * from "./SubMenuTab_Base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports